import { render, staticRenderFns } from "./log-warning.vue?vue&type=template&id=2cfc50ec&scoped=true&lang=pug&"
import script from "./log-warning.vue?vue&type=script&lang=js&"
export * from "./log-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc50ec",
  null
  
)

export default component.exports